import * as Leaflet from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'vue-leaflet-markercluster/dist/style.css'

type LeafletWithCluster = typeof Leaflet & {
  markerClusterGroup?: (options?: object) => unknown
  MarkerClusterGroup?: unknown
}

/**
 * `vue-leaflet-markercluster` lee `globalThis.L.markerClusterGroup` al montar.
 * Hay que exponer Leaflet en global y extenderlo con markercluster antes del mapa.
 */
const scope = globalThis as typeof globalThis & { L: LeafletWithCluster }
scope.L = Leaflet as LeafletWithCluster

export default defineNuxtPlugin(async () => {
  if (typeof scope.L.markerClusterGroup !== 'function') {
    // El paquete no publica tipos; el side-effect extiende `globalThis.L`.
    // @ts-expect-error — sin declaration file para leaflet.markercluster
    await import('leaflet.markercluster')
  }

  return {
    provide: {
      L: scope.L
    }
  }
})
